import { useEffect, useState } from 'react';
import { getTeamDetails } from '../common/apiClient';
import { isLeader } from './teamMembership';

const NO_TEAMS = { primaryIds: [], secondaryIds: [], loaded: true, error: '' };
const LOADING = { primaryIds: [], secondaryIds: [], loaded: false, error: '' };

// Returned objects keep a stable identity so callers can use them as effect dependencies.
export const useTeamLeaders = (teamIds) => {
    const key = teamIds.join(',');
    const [result, setResult] = useState({ ...NO_TEAMS, key: '' });

    useEffect(() => {
        if (!key) return;
        let cancelled = false;
        Promise.all(key.split(',').map((teamId) => getTeamDetails(teamId)))
            .then((teams) => {
                if (teams.some((team) => !Array.isArray(team.members))) throw new Error('Missing team roster');
                const leaders = teams.flatMap((team) => team.members.filter(isLeader));
                if (!cancelled) setResult({
                    key,
                    primaryIds: leaders.filter((member) => !member.isSecondary).map((member) => member.userId),
                    secondaryIds: leaders.filter((member) => member.isSecondary).map((member) => member.userId),
                    loaded: true,
                    error: '',
                });
            })
            .catch(() => {
                if (!cancelled) setResult({
                    ...NO_TEAMS,
                    key,
                    error: 'Unable to verify primary supervisors. Please refresh and try again.',
                });
            });
        return () => { cancelled = true; };
    }, [key]);

    if (!key) return NO_TEAMS;
    return result.key === key ? result : LOADING;
};
